// extracted by mini-css-extract-plugin
export default {"container":"Hero_container__-s7wo","title":"Hero_title__rL9MQ","text":"Hero_text__ht4xS","heroImage":"Hero_heroImage__WlCwT","heroBtn":"Hero_heroBtn__yz-dP"};